import React, { useMemo } from 'react';

import styled from 'styled-components';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import {
  Checkbox,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';

const StyledWrapper = styled.div`
  margin-bottom: 20px;
`;

const StyledTitle = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
`;

const StyledOption = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .checkbox {
    margin: 0;
    margin-right: 20px;

    input {
      width: 21px;
      height: 21px;
    }
  }

  p {
    margin: 0;
  }
`;

const StyledGuestWrapper = styled.div`
  input {
    width: 10%;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const EventBookableAttendees = ({ attendees, members, onOrderStateChange }) => {
  const getMemberSelectedStatus = member => {
    return (
      member &&
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      attendees.find(attendee => attendee.memberId === member.memberId)
    );
  };

  const onAttendeesByMembersChange = member => {
    let attendeesClone = cloneDeep(attendees);
    const isMemberSelected = getMemberSelectedStatus(member);
    if (isMemberSelected) {
      attendeesClone = attendeesClone.filter(
        attendee => attendee.memberId !== member.memberId
      );
    } else {
      attendeesClone.push(member);
    }
    onOrderStateChange('attendees', attendeesClone);
  };

  const onGuestsChange = ({ target }) => {
    const attendeesClone = cloneDeep(attendees);
    const attendeesWithoutGuests = attendeesClone.filter(attendee =>
      isEmpty(attendee)
    );
    const guests = new Array(+target.value).fill({});
    const attendeesWithNewGuestsQuantity = [
      ...attendeesWithoutGuests,
      ...guests,
    ];
    onOrderStateChange('attendees', attendeesWithNewGuestsQuantity);
  };

  const guestsQuantity = useMemo(
    () => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      const guests = attendees.filter(attendee => isEmpty(attendee));
      return guests.length;
    }, // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    [attendees.length]
  );

  return (
    <StyledWrapper>
      <StyledTitle>Attendees</StyledTitle>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {members.map(member => (
        <StyledOption key={member.memberId}>
          <Checkbox
            checked={!!getMemberSelectedStatus(member)}
            onChange={() => onAttendeesByMembersChange(member)}
          />
          <p>{member.memberName}</p>
        </StyledOption>
      ))}
      <StyledGuestWrapper>
        <FormGroup controlId='guests'>
          <ControlLabel>Additional guests not listed here</ControlLabel>
          <FormControl
            type='text'
            onChange={onGuestsChange}
            value={guestsQuantity}
          />
        </FormGroup>
      </StyledGuestWrapper>
    </StyledWrapper>
  );
};

export default EventBookableAttendees;
